import DetailsIcon from "@mui/icons-material/Details";
import GroupIcon from "@mui/icons-material/Group";
import HelpIcon from "@mui/icons-material/Help";
import PersonIcon from "@mui/icons-material/Person";
import { useTheme } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import OmniAvatar from "./omniAvatar";
import OmniListItemButton from "./omniListItemButton";

const OmniCommunicationQueryListItem = props => {
  const { inviteQuery, onNavigateHandler = null, isTypeSupported = false } = props;
  const theme = useTheme();

  const getAvatarIcon = inviteType => {
    if (inviteType === "single") {
      return <PersonIcon />;
    } else if (inviteType === "shared") {
      return <GroupIcon />;
    } else {
      return <HelpIcon />;
    }
  };

  return (
    <ListItem
      disableGutters={true}
      sx={{
        padding: theme.spacing(1),
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: theme.spacing(1),
        borderRadius: theme.spacing(1),
        backgroundColor: isTypeSupported ? theme.palette.success.main : theme.palette.info.main,
        color: theme.palette.info.contrastText,
        boxShadow: theme.shadows[3],
        userSelect: "none",
        webkitUserSelect: "none",
      }}
    >
      <Tooltip title={"Click to Toggle"} placement="right">
        <OmniAvatar
          sx={{
            width: 36,
            height: 36,
            fontSize: "1.2rem",
            backgroundColor: isTypeSupported ? theme.palette.success.main : theme.palette.info.main,
            border: `2px solid ${theme.palette.info.contrastText}`,
          }}
        >
          {getAvatarIcon(inviteQuery.query["omniData.inviteType"]["#regex"])}
        </OmniAvatar>
      </Tooltip>
      <ListItemText
        primary={
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              flexDirection: "column",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: theme.palette.info.contrastText,
              marginTop: 0,
              textTransform: "capitalize",
            }}
          >
            {`Invite Type: ${inviteQuery.query["omniData.inviteType"]["#regex"]}`}
          </Typography>
        }
        secondary={
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              flexDirection: "row",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginTop: "-6px",
              color: theme.palette.info.contrastText,
              minimumHeight: 20,
              textTransform: "capitalize",
            }}
          >
            {inviteQuery.query["omniData.invitationStatus"]["#regex"]}
            {` (Target: ${inviteQuery.query["omniData.target"]["#regex"]})`}
          </Typography>
        }
      />
      {onNavigateHandler && (
        <OmniListItemButton
          title={"Check Status"}
          sx={{
            marginTop: "1px",
            marginRight: "1px",
          }}
          size="large"
          onClick={e => {
            e.stopPropagation();
            //  window.location.reload();
            //todo ImplmentNavigation
          }}
          icon={<DetailsIcon />}
        />
      )}
    </ListItem>
  );
};

export default OmniCommunicationQueryListItem;
